const data = {
  homepage: {
    season: "SUMMER 2023",
    newCollection: "NEW COLLECTION",
    newCollectionInfo:
      "We know how large objects will act, but things on a small scale.",
    newCollectionBtn: "SHOP NOW",
  },
  bestSeller: {
    products: {
      product1: {
        title1: "Featured Products",
        title2: "BESTSELLER PRODUCTS",
        titleInfo: "Problems trying to resolve the conflict between",
        productTitle: "Graphic Design",
        productInfo: "English Department",
        productPrice: "$16.48",
        productPrice2: "$6.48",
      },
      product2: {
        title1: "Featured Products",
        title2: "BESTSELLER PRODUCTS",
        titleInfo: "Problems trying to resolve the conflict between",
        productTitle: "Graphic Design",
        productInfo: "English Department",
        productPrice: "$16.48",
        productPrice2: "$6.48",
      },
      product3: {
        title1: "Featured Products",
        title2: "BESTSELLER PRODUCTS",
        titleInfo: "Problems trying to resolve the conflict between",
        productTitle: "Graphic Design",
        productInfo: "English Department",
        productPrice: "$16.48",
        productPrice2: "$6.48",
      },
      product4: {
        title1: "Featured Products",
        title2: "BESTSELLER PRODUCTS",
        titleInfo: "Problems trying to resolve the conflict between",
        productTitle: "Graphic Design",
        productInfo: "English Department",
        productPrice: "$16.48",
        productPrice2: "$6.48",
      },
      product5: {
        title1: "Featured Products",
        title2: "BESTSELLER PRODUCTS",
        titleInfo: "Problems trying to resolve the conflict between",
        productTitle: "Graphic Design",
        productInfo: "English Department",
        productPrice: "$16.48",
        productPrice2: "$6.48",
      },
      product6: {
        title1: "Featured Products",
        title2: "BESTSELLER PRODUCTS",
        titleInfo: "Problems trying to resolve the conflict between",
        productTitle: "Graphic Design",
        productInfo: "English Department",
        productPrice: "$16.48",
        productPrice2: "$6.48",
      },
      product7: {
        title1: "Featured Products",
        title2: "BESTSELLER PRODUCTS",
        titleInfo: "Problems trying to resolve the conflict between",
        productTitle: "Graphic Design",
        productInfo: "English Department",
        productPrice: "$16.48",
        productPrice2: "$6.48",
      },
      product8: {
        title1: "Featured Products",
        title2: "BESTSELLER PRODUCTS",
        titleInfo: "Problems trying to resolve the conflict between",
        productTitle: "Graphic Design",
        productInfo: "English Department",
        productPrice: "$16.48",
        productPrice2: "$6.48",
      },
      product9: {
        title1: "Featured Products",
        title2: "BESTSELLER PRODUCTS",
        titleInfo: "Problems trying to resolve the conflict between",
        productTitle: "Graphic Design",
        productInfo: "English Department",
        productPrice: "$16.48",
        productPrice2: "$6.48",
      },
      product10: {
        title1: "Featured Products",
        title2: "BESTSELLER PRODUCTS",
        titleInfo: "Problems trying to resolve the conflict between",
        productTitle: "Graphic Design",
        productInfo: "English Department",
        productPrice: "$16.48",
        productPrice2: "$6.48",
      },
      product11: {
        title1: "Featured Products",
        title2: "BESTSELLER PRODUCTS",
        titleInfo: "Problems trying to resolve the conflict between",
        productTitle: "Graphic Design",
        productInfo: "English Department",
        productPrice: "$16.48",
        productPrice2: "$6.48",
      },
      product12: {
        title1: "Featured Products",
        title2: "BESTSELLER PRODUCTS",
        titleInfo: "Problems trying to resolve the conflict between",
        productTitle: "Graphic Design",
        productInfo: "English Department",
        productPrice: "$16.48",
        productPrice2: "$6.48",
      },
    },

    productBtn: "LOAD MORE PRODUCTS",
  },
  featured: {
    title1: "Featured Products",
    title2: "We Love What We Do",
    featuredInfo:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Natus,quod. Lorem ipsum dolor sit amet consectetur adipisicing elit.Natus, quod. Lorem ipsum dolor sit amet consectetur adipisicing elit.",
  },
  service: {
    title1: "Featured Products",
    title2: "THE BEST SERVICES",
    titleInfo: "Problems trying to resolve the conflict between",
    firstIconTitle: "Easy Wins",
    firstIconInfo: "Get your best looking smile now",
    secondIconTitle: "Concrete",
    secondIconInfo:
      "Defalcate is most focused in helping you discover your most beautiful smile",
    thirdIconTitle: "Hack Growth",
    thirdIconInfo: "Overcame any hurdle or any other problem",
  },
  featuredPost: {
    title1: "Practice Advice",
    title2: "Featured Posts",
    sale: "Sale",
    commentRate: "4.9",
    postTitle: "English Department",
    postTitle2: "Graphic Design",
    postInfo:
      "We focus on ergonomics and meeting you where you work. It's only a keystoke away",
    postInfo2:
      "We focus on ergonomics and meeting you where you work. It's only a keystoke away",
    saleInfo: "15 Sales",
    price: "$16.48",
    price2: "$6.48",
    leftTime: "22 h..",
    lessons: "64 Lessons",
    progress: "Progress",
    learnMore: "Learn More",
  },
  productList: {
    label: "Showing all 12 results",
    shop: "Shop",
    home: "Home",
    views: "Views",
  },
};
export default data;
